import { render, staticRenderFns } from "./TooltipCourseInfo.vue?vue&type=template&id=6b769a22&scoped=true&lang=pug&"
import script from "./TooltipCourseInfo.vue?vue&type=script&lang=js&"
export * from "./TooltipCourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./TooltipCourseInfo.vue?vue&type=style&index=0&id=6b769a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b769a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
